import MuiMenuItem, { type MenuItemProps as MuiMenuItemProps } from '@mui/material/MenuItem'
import { styled } from '@mui/material/styles'
import React from 'react'

import CustomTooltip from './tooltip'

type MenuItemProps = MuiMenuItemProps & {
  tooltip?: string
}

const MenuItem: React.FC<MenuItemProps> = ({ disabled, tooltip, onClick, ...props }) => {
  const [open, setOpen] = React.useState(false)

  const handleClick = React.useCallback(
    (e: React.MouseEvent<HTMLLIElement>) => {
      setOpen(false)
      onClick?.(e)
    },
    [onClick],
  )

  const handleMouseEnter = React.useCallback(() => {
    setOpen(true)
  }, [])

  const handleMouseLeave = React.useCallback(() => {
    setOpen(false)
  }, [])

  if (!tooltip) {
    return <MuiMenuItem {...props} disabled={disabled} onClick={disabled ? undefined : handleClick} />
  }

  return (
    <CustomTooltip open={open} title={tooltip}>
      <div>
        <TooltipMenuItem
          {...props}
          disabled={disabled}
          onClick={disabled ? undefined : handleClick}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </div>
    </CustomTooltip>
  )
}

const TooltipMenuItem = styled(MuiMenuItem)({
  '&.Mui-disabled': {
    pointerEvents: 'auto',
  },
})

export default MenuItem
